export default from './button';



// WEBPACK FOOTER //
// ./app/components/button/index.js